import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Therapists from "../pages/therapists/page";
import TherapistBio from "../pages/therapist/page";
import TeenTherapy from "../pages/teen-therapy/page";
import IndividualTherapy from "../pages/individual-therapy/page";
import CouplesTherapy from "../pages/couples-therapy/page";
import ChildTherapy from "../pages/child-therapy/page";
import GroupTherapy from "../pages/group-therapy/page";
import Contact from "../pages/contact/page";
import FullPricing from "../pages/full-pricing/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsConditions from "../pages/terms-conditions/page";
import GoodFaithEstimate from "../pages/good-faith-estimate/page";
import Blog from "../pages/blog/page";
import BlogAll from "../pages/blog/all/page";
import BlogArticle from "../pages/blog/article/page";
import Sitemap from "../pages/sitemap/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/therapists",
    element: <Therapists />,
  },
  {
    path: "/kinder-bradley",
    element: <TherapistBio profileId="kinder-bradley" />,
  },
  // Legacy and noncanonical URLs resolve to the single public profile.
  ...["/kinder-adams", "/therapists/kinder-adams", "/therapists/kinder-bradley"].map((path) => ({
    path,
    element: <Navigate to="/kinder-bradley" replace />,
  })),
  {
    path: "/therapists/:id",
    element: <TherapistBio />,
  },
  {
    path: "/teen-therapy",
    element: <TeenTherapy />,
  },
  {
    path: "/individual-therapy",
    element: <IndividualTherapy />,
  },
  {
    path: "/couples-therapy",
    element: <CouplesTherapy />,
  },
  {
    path: "/child-therapy",
    element: <ChildTherapy />,
  },
  {
    path: "/group-therapy",
    element: <GroupTherapy />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/full-pricing",
    element: <FullPricing />,
  },
  {
    path: "/therapy-packages",
    element: <FullPricing />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-conditions",
    element: <TermsConditions />,
  },
  {
    path: "/good-faith-estimate",
    element: <GoodFaithEstimate />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/all",
    element: <BlogAll />,
  },
  {
    path: "/blog/:slug",
    element: <BlogArticle />,
  },
  {
    path: "/sitemap",
    element: <Sitemap />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
